"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToIntegerIfIntegral = void 0;
var ecma402_abstract_1 = require("@formatjs/ecma402-abstract");
function ToIntegerIfIntegral(arg) {
    var number = (0, ecma402_abstract_1.ToNumber)(arg);
    if (!Number.isInteger(number)) {
        throw new RangeError("".concat(arg, " is not an integer"));
    }
    return number;
}
exports.ToIntegerIfIntegral = ToIntegerIfIntegral;
